module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/tankodrome-lvl1-50.f9f7be31.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/tankodrome-lvl1-50.png
// module id = 3553
// module chunks = 11